<template>
  <v-form ref="frmTsEval" lazy-validation validate-on="submit" @submit.prevent="saveTimeSheetEvaluation">
    <v-card :loading="loading" max-width="600" prepend-icon="mdi-history" text="How do you evaluate this time sheet?"
      title="Time Sheet Evaluation">
      <v-card-text>
        <pre>Your Score to this time sheet:</pre>
        <div class="text-center align-center justify-center mb-4">
          <v-rating :rules="[validations.RequiredCheck]" v-model="timesheetEvaluation.evaluationScore"
            :item-labels="timeSheetLabels" empty-icon="mdi-circle-outline" full-icon="mdi-circle"
            half-icon="mdi-circle-half" half-increments hover>
            <template v-slot:item-label="props">
              <span :class="`text-${timeSheetLabelsColors[props.index]}`" class="font-weight-black text-caption">
                {{ props.label }}
              </span>
            </template>
          </v-rating>
          <pre>{{ timesheetEvaluation.evaluationScore ?? 0 }}/5</pre>
        </div>
        <pre>Which one most influences your response?</pre>
        <div class="text-center align-center justify-center">
          <v-radio-group :rules="[validations.RequiredCheck]" v-model="timesheetEvaluation.descriptionLabel" color="accent">
            <v-radio label="Disciplined/On Time" value="CreationTime"></v-radio>
            <v-radio label="Good Description" value="Description"></v-radio>
            <v-radio label="Detail" value="Detail"></v-radio>
            <v-radio label="Not Disciplined/On Time" value="BadCreationTime"></v-radio>
            <v-radio label="Not Good Description" value="BadDescription"></v-radio>
            <v-radio label="Not Detail" value="BadDetail"></v-radio>
          </v-radio-group>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn class="bg-white" @click="$emit('close')" elevated>Cancel</v-btn>
        <v-btn class="bg-white" type="submit" elevated>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { TimesheetApi, TimesheetEvaluationModel } from "../../services/openApi/api";
import validations from "../../utils/validations";

export default defineComponent({
  props: {
    timeSheetId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      validations,
      loading: false,
      timesheetEvaluation: {} as TimesheetEvaluationModel,
      timeSheetLabelsColors: ["grey", "grey", "grey", "grey", "grey"],
      timeSheetLabels: ["bad", "so so", "ok", "good", "great"],
    }
  },
  methods: {
    async saveTimeSheetEvaluation() {
      const isValid = (await (this.$refs.frmTsEval as any).validate()).valid;
      if (isValid) {
        this.loading = true;
        await new TimesheetApi().evaluateTimesheet(this.timesheetEvaluation)
          .then((rsp: any) => this.$emit("successRaised", "Your Evaluation Saved Successfully"))
          .catch((err: any) => this.$emit("errorRaised", err.response.data));
        this.loading = false;
        this.$emit("close");
      }
    },
  },
  async mounted() {
    this.loading = true;
    await new TimesheetApi().getTimesheetEvaluation(this.timeSheetId)
      .then((rsp: any) => this.timesheetEvaluation = rsp.data)
      .catch((err: any) => this.$emit("errorRaised", err.response.data));
    this.timesheetEvaluation.timesheetId = this.timeSheetId;
    this.loading = false;
  }
});
</script>
